import { filter } from 'lodash';

export const randomString = () => {
    let random_string = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';
    for (let i = 0; i < 10; i++) {
        random_string += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return random_string;
};

export const randomNumber = () => {
    let string = '';
    for (let i = 0; i < 10; i++) {
        string += Math.floor(Math.random() * 10);
    }
    return string;
};

export const mapCofidisCart = (cart, partners) => {
    if (cart.length > 0) {
        const partner = filter(partners, p => p.id === cart[0].partnerId)[0];

        return cart.map(item => {
            return {
                itemQuantity: item.quantityQuery.toString(),
                itemAmount: (item.facialValue * 100).toString(),
                itemReference: partner.id
            };
        });
    }
    return [];
};



// WEBPACK FOOTER //
// ./src/services/cofidis/utils.js